import { Box, Stack, SxProps, Theme, Typography, useTheme } from '@mui/material';
import { FC, ReactElement } from 'react';
import { rgba } from 'polished';

interface Props {
    label: string;
    value?: ReactElement | string;
    sx?: SxProps<Theme>;
}

export const LabelValue: FC<Props> = ({ label, value, sx }) => {
    const theme = useTheme();

    return (
        <Stack sx={{ mb: 1, ...sx }}>
            <Typography
                variant="description"
                sx={{
                    textTransform: 'uppercase',
                    fontWeight: 'bold',
                    color: rgba(0, 0, 0, 0.6),
                }}
            >
                {label}
            </Typography>
            {value ? (
                <>
                    {value instanceof String ? (
                        <Typography variant="caption">{value || '-'}</Typography>
                    ) : (
                        <Box
                            sx={{
                                fontSize: theme.typography.caption.fontSize,
                                fontFamily: theme.typography.caption.fontFamily,
                            }}
                        >
                            {value}
                        </Box>
                    )}
                </>
            ) : (
                <Typography>{'-'}</Typography>
            )}
        </Stack>
    );
};
